import { ChangeAction } from 'app/KinerjaShared/components/PenetapanPredikatTable/ChangeAction'
import { DownloadAction } from 'app/KinerjaShared/components/PenetapanPredikatTable/DownloadAction'
import { Pagination } from 'app/KinerjaShared/components/PenetapanPredikatTable/Pagination'
import { PaginationSize } from 'app/KinerjaShared/components/PenetapanPredikatTable/PaginationSize'
import { PredikatFilter } from 'app/KinerjaShared/components/PenetapanPredikatTable/PredikatFilter'
import { Provider } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'
import { Search } from 'app/KinerjaShared/components/PenetapanPredikatTable/Search'
import { SelectionToolbar } from 'app/KinerjaShared/components/PenetapanPredikatTable/SelectionToolbar'
import { SendAction } from 'app/KinerjaShared/components/PenetapanPredikatTable/SendAction'
import { StatusPengirimanFilter } from 'app/KinerjaShared/components/PenetapanPredikatTable/StatusPengirimanFilter'
import { Table } from 'app/KinerjaShared/components/PenetapanPredikatTable/Table'
import { Title } from 'app/KinerjaShared/components/PenetapanPredikatTable/Title'

const PenetapanPredikatTable = {
  ChangeAction,
  DownloadAction,
  Pagination,
  PaginationSize,
  PredikatFilter,
  Provider,
  Search,
  SelectionToolbar,
  SendAction,
  StatusPengirimanFilter,
  Table,
  Title,
}

export * from 'app/KinerjaShared/components/PenetapanPredikatTable/constants'
export * from 'app/KinerjaShared/components/PenetapanPredikatTable/utils'
export * from 'app/KinerjaShared/components/PenetapanPredikatTable/type'

export default PenetapanPredikatTable
